

export const api_constants = {
    urls: {
        base_url: "https://secrets-rest-api.onrender.com",
        // base_url: "http://localhost:3000",
        privacy_policy: "/legal/privacy-policy",
        tos: "/legal/terms-and-conditions",
        joinBeta: "/dev/register-for-closed-beta"
    }
}